import { Group } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import AddItemButton from "@/components/add-item-button";
import { TModalProperties } from "@/components/add-item-button/AddItemButton";
import useGetColaboradorById from "@/modules/colaboradores/hooks/useGetColaboradorById";
import ideiaSchema from "@/modules/ideias/schema/ideia-schema";
import useUserStore from "@/modules/users/store";
import { getCurrentUser } from "@/services/auth";
import { dataAutorizacoes } from "../empresa-page/EmpresaPage";

const modalProperties: TModalProperties = {
  modal: "ideia-form-modal",
  closeOnClickOutside: false
};

// prettier-ignore
const AddIdeiaButton = () => {
  const activeEmpresaId = useUserStore((store) => store.activeEmpresa);
  const activeAutorizacao = useUserStore((store) => store.autorizacoes);
  const uid = getCurrentUser()?.uid;
  const { data: userColaborador } = useGetColaboradorById(activeEmpresaId?.id || "", uid || "");
  const autorizacao = dataAutorizacoes.find(item => item.label === userColaborador?.role);
  const formatAutorizacoes = activeAutorizacao?.filter(item => item.tipo === autorizacao?.value);

  return (
    <Group justify={"flex-end"}>
      {formatAutorizacoes?.find(item => item.tipoAutorizacao === "3")?.criacao ? <AddItemButton
        size="sm"
        leftSection={<IconPlus size="1rem" />}
        modalProperties={modalProperties}
        schema={ideiaSchema}
      >
        Adicionar Ideia
      </AddItemButton> : <></>}
    </Group>
  );
};

export default AddIdeiaButton;
